module.exports = __webpack_public_path__ + "img/copy.6d9e76e8.svg";